import { Component, Input, Output, EventEmitter } from '@angular/core';

import { QuoteService } from '../../../quote/services/quote.service';
import { Quote } from '../../models/quote.interface';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-project-info',
  templateUrl: './project.info.component.html',
  styleUrls: ['./project.info.component.scss']
})
export class ProjectInfoShellComponent {

  isMobile: boolean;

  projectTypeIn: string;
  quoteIn: Quote;
  customerIdIn: number;

  constructor( private deviceDetectorService: DeviceDetectorService) {
    this.isMobile = !this.deviceDetectorService.isDesktop();
  }

  @Input()
  public set quote(value: Quote) {
    this.quoteIn = value;
  }

  @Input()
  public set customerId(value: number) {
    this.customerIdIn = value;
  }

  @Input()
  public set projectType(value: string) {
    this.projectTypeIn = value;
  }

  @Output() updated = new EventEmitter<Quote>();

  quoteUpdated(quote: Quote) {
    this.updated.emit(quote);
  }
}
